import { DataframeDataRetrievalRequest } from '../api/types';
import { TNewDateRange } from '../api/types/TNewDateRange';

// Download as CSV/XLSX must re-fetch (the on-screen data is row-capped) and must send the request the
// screen used: its `override` is the only carrier of on-screen filters, pivots, sort and drill state.
// The id/date fallback exports the saved definition, so it is only for callers without one.
export const buildExportRequest = (
	onScreenRequest: DataframeDataRetrievalRequest | undefined,
	dataframeId: number | undefined,
	selectedDate: TNewDateRange | undefined
): DataframeDataRetrievalRequest => {
	if (onScreenRequest) {
		return { ...onScreenRequest, bypassLimit: true };
	}

	return {
		dataframeId: dataframeId ?? 0,
		begin_date: selectedDate?.begin_date ?? 0,
		end_date: selectedDate?.end_date ?? 0,
		periodId: selectedDate?.period ?? 0,
		bypassLimit: true,
	};
};
